import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/layout/Header";
import Protected from "./components/layout/Protected";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import GoogleCallback from "./pages/GoogleCallback";
import Terminal from "./pages/Terminal";
import Wallet from "./pages/Wallet";
import Positions from "./pages/Positions";
import Bots from "./pages/Bots";
import HowItWorks from "./pages/HowItWorks";
import Fees from "./pages/Fees";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminSwaps from "./pages/AdminSwaps";
import AdminConfig from "./pages/AdminConfig";
import AdminFees from "./pages/AdminFees";
import AdminFeesSwap from "./pages/AdminFeesSwap";
import AdminAds from "./pages/AdminAds";
import AdminTreasury from "./pages/AdminTreasury";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminDeposits from "./pages/AdminDeposits";
import AdminSettings from "./pages/AdminSettings";
import OnChainTape from "./pages/OnChainTape";
import MyOnChain from "./pages/MyOnChain";
import Proof from "./pages/Proof";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/fees" element={<Fees />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/auth/google/callback" element={<GoogleCallback />} />
                    <Route path="/terminal" element={<Protected><Terminal /></Protected>} />
                    <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
                    <Route path="/positions" element={<Protected><Positions /></Protected>} />
                    <Route path="/bots" element={<Protected adminOnly><Bots /></Protected>} />
                    <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
                    <Route path="/admin/users" element={<Protected adminOnly><AdminUsers /></Protected>} />
                    <Route path="/admin/swaps" element={<Protected adminOnly><AdminSwaps /></Protected>} />
                    <Route path="/admin/config" element={<Protected adminOnly><AdminConfig /></Protected>} />
                    <Route path="/admin/fees" element={<Protected adminOnly><AdminFees /></Protected>} />
                    <Route path="/admin/fees/swap/:swapId" element={<Protected adminOnly><AdminFeesSwap /></Protected>} />
                    <Route path="/admin/ads" element={<Protected adminOnly><AdminAds /></Protected>} />
                    <Route path="/admin/treasury" element={<Protected adminOnly><AdminTreasury /></Protected>} />
                    <Route path="/admin/analytics" element={<Protected adminOnly><AdminAnalytics /></Protected>} />
                    <Route path="/admin/deposits" element={<Protected adminOnly><AdminDeposits /></Protected>} />
                    <Route path="/admin/settings" element={<Protected adminOnly><AdminSettings /></Protected>} />
                    <Route path="/onchain" element={<OnChainTape />} />
                    <Route path="/me/onchain" element={<Protected><MyOnChain /></Protected>} />
                    <Route path="/proof/:swapId" element={<Proof />} />
                </Routes>
                <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0A0C", color: "#f4f4f5", border: "1px solid #1F1F24", fontFamily: "IBM Plex Mono, monospace", borderRadius: "2px" } }} />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
